/**
 * external libs
 */
import React, {useEffect, useRef, useState} from 'react'
import {InputNumber} from "antd";
/**
 * styles
 */
import styles from './index.module.scss'
/**
 * enums
 */
import FieldItem from "../../../../../Form/components/FieldItem";



export default function EditableIntNumberWidget({resultValue, isFocused = true, validationErrorMessage, widget, onEdit, field, onBlur, result}) {
    const [resultData, setResultData] = useState(result)
    const inputRef = useRef(null)

    const updateResult = (newVal) => {
        const newMeasuresValue = field ? {
            ...resultData.measures,
            [field]: newVal,
        } : newVal
        const updatedData = {
            ...resultData,
            is_modified: true,
            measures: newMeasuresValue
        }
        setResultData(updatedData)
        onEdit(updatedData)
    }

    const onBlurHandler = () => {
        if (onEdit) {
            onEdit(resultData)
        }

        if (onBlur) {
            onBlur(resultData)
        }
    }

    const onChangeHandler = (number) => {
        let value = number === null ? "" : String(number)
        value = value.replace(/\s+/g, '').replace(/\D/g, '')
        if (value === "") {
            updateResult(null)
            return
        }
        const numericValue = parseInt(value, 10)
        if (isNaN(numericValue)) return

        const newMeasuresValue = field ? {
            ...resultData.measures,
            [field]: numericValue,
        } : numericValue

        if(numericValue >= widget.maximum){
            onBlur({
                ...resultData,
                is_modified: true,
                measures: newMeasuresValue
            })
        }

        const updatedData = {
            ...resultData,
            is_modified: true,
            measures: newMeasuresValue
        }
        setResultData(updatedData)
        onEdit(updatedData)
    }

    const handlePaste = (e) => {
        e.preventDefault()
        let pasteData = e.clipboardData.getData('text/plain')
        pasteData = pasteData.replace(/\s+/g, '').replace(/\D/g, '')
        if(pasteData === ""){
            updateResult(null)
            return
        }
        const numericValue = parseInt(pasteData, 10)
        if(isNaN(numericValue)) return
        onChangeHandler(numericValue)
    }

    useEffect(() => {
        setResultData(result)
    }, [result])

    useEffect(() => {
        if(isFocused){
            inputRef.current.select()
        }
    }, [])


    const currentValue = (field ? resultData.measures?.[field] : resultData.measures) ?? ""

    return (
        <FieldItem label={widget.description || ""}
                   requiredColor={resultValue !== null ? "#1084FF" : "red"}
                   required={!widget.type.includes("null")} stylesWrapper={{marginBottom: 10}} error={validationErrorMessage}>
            <div className={styles.wrapper} style={{maxWidth: 500, width: 500}}>
                <InputNumber rootClassName={styles.wrapper__input}
                             value={currentValue}
                             ref={inputRef}
                             suffix={widget?.['x-unit']}
                             min={widget.exclusiveMinimum ? widget.minimum + 1 : widget.minimum}
                             max={widget.exclusiveMaximum ? widget.maximum - 1 : widget.maximum}
                             formatter={(value) => {
                                 if(!value || !String(value).length){
                                     return ""
                                 }
                                 return String(value)
                             }}
                             parser={value => {
                                 if(!value || !value.length){
                                     return ""
                                 }
                                 return value.replace(/\s+/g, '').replace(/\D/g, '')
                             }}
                             onChange={onChangeHandler}
                             onBlur={onBlurHandler}
                             onPaste={handlePaste}
                />
            </div>
        </FieldItem>
    )
}
